import { toast, Bounce } from "react-toastify";

const configurationToastify = {
  position: "top-right",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: false,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: "dark",
  transition: Bounce,
};

export const SuccessMessage = (message = "Operación exitosa", options = {}) => {
  const config = {
    ...configurationToastify,
    ...options,
  };

  return toast.success(message, config);
};

export const ErrorMessage = (
  message = "Ha ocurrido un error",
  options = {}
) => {
  const config = {
    ...configurationToastify,
    ...options,
  };
  return toast.error(message, config);
};

export const WarningMessage = (
  message = "Revisa los datos nuevamente ",
  options = {}
) => {
  const config = {
    ...configurationToastify,
    ...options,
  };
  return toast.warning(message, config);
};

export const InfoMessage = (message = "Información", options = {}) => {
  const config = {
    ...configurationToastify,
    ...options,
  };
  return toast.info(message, config);
};
